import { getEnvVariable } from '@ciam/env';
export const CURRENT_CHANNEL = new URLSearchParams(window.location.search).get('channel') ?? 'btp';
export const GIGYA_API_KEY = getEnvVariable(`VITE_GIGYA_API_KEY_${CURRENT_CHANNEL.toUpperCase()}`);
export const CDNS_URL = getEnvVariable('VITE_GIGYA_API_URL');
//# sourceMappingURL=index.js.map